import React, {useState, useContext, useRef} from "react";
import classnames from "classnames";
import {Async as AsyncSelect} from "react-select";
import "whatwg-fetch";
import {debounce} from "underscore";
import {useOnClickOutside} from "../../../../utils/use-on-click-outside";
import {RegionsList} from "../RegionsList";
import {Context} from "../../index";
import {changeRegion, loadRegions} from "../../../../services/regions";

import styles from "./geopicker.module.scss";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "../../../common/Icons/CloseIcon";

export function GeoPicker() {
  const [isOpen, setIsOpen] = useState(false);
  const {authenticityToken, location} = useContext(Context);
  const containerRef = useRef(null);

  useOnClickOutside(containerRef, () => setIsOpen(false));

  return (
    <div className={styles.container} ref={containerRef}>
      <button
        type="button"
        className={classnames(styles.button, {[styles.active]: isOpen})}
        onClick={() => setIsOpen(!isOpen)}
      >
        {location}
      </button>
      {isOpen && (
        <div className={styles.box}>
          <div className={styles.bar}>
            <AsyncSelect
              className={styles.input}
              onChange={({value, label, name}) =>
                changeRegion(authenticityToken, {
                  fiasID: value,
                  fullName: label,
                  name
                })
              }
              loadOptions={debounce(loadRegions, 200, true)}
              loadingMessage={() => `Загрузка...`}
              noOptionsMessage={({inputValue}) =>
                `По запросу ${inputValue} ничего не найдено`
              }
              placeholder="Населённый пункт"
            />
            <IconButton
              onClick={() => setIsOpen(false)}
              className={styles.closeButton}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <RegionsList />
        </div>
      )}
    </div>
  );
}
